import { model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { UserModel } from '../Viewer/UserModel';

export class Track extends Model({
  id: types.identifierNumber,
  title: types.string,
  cover: types.string,
  description: types.string,
  uploadDate: types.string,
  userUploadId: types.integer,
  user: types.reference(UserModel),
}) {}

export const TrackModel = model(Track);
// We set this name manually because after building the project into production
// mode code will be obfuscated and in the build js code class Post will get
// another name, class R for example. But we need this name to check parentEntity
// type (parentEntityName), for this case, we are using model names. The best way
// is to use parent.is(PostModel) but due to an import cycled dependency issue we
// cannot import PostModel or Post class into needed files, so we are using parent.name
// to detect the parent's model type (Post, Tutorial, or Track, etc)
// TODO: find a way to import Models in needed files
// (take a look at parentEntityName and parentEntity in CommentListModel and LikesUserList)
TrackModel.name = 'Track';
